import React, { useState } from 'react'
import { Modal, Button, Table, Alert } from 'react-bootstrap'
import { useStateValue } from '../state'
import { payments as endpoints } from '../../api_urls'
import { client } from '../../utils'
import ButterToast, { Cinnamon } from 'butter-toast'

const RoyaltiesToPayModal = () => {
  const [currentState, dispatch] = useStateValue()
  const [royaltiesWorking, toggleRoyaltiesWorking] = useState(false)

  const submitRoyalties = async () => {
    toggleRoyaltiesWorking(true)
    for (var i = 0; i < currentState.royaltiesOwed.length; i++) {
      let royalty = currentState.royaltiesOwed[i]
      client
        .post(endpoints.initiateTransfers(), royalty)
        .then(() => {
          ButterToast.raise({
            content: (
              <Cinnamon.Crunch
                title="Success"
                content={`Successfully scheduled a royalty payment for ${royalty['user_full_name']}. It may take up to 5 days to reflect in the author's account.`}
                scheme={Cinnamon.Crisp.SCHEME_GREEN}
                icon={<i className="far fa-check fa-3x" />}
              />
            ),
          })
        })
        .catch(err => {
          ButterToast.raise({
            content: (
              <Cinnamon.Crunch
                title="Error"
                content={err.response.data.error}
                scheme={Cinnamon.Crisp.SCHEME_RED}
                icon={<i className="far fa-exclamation-triangle fa-3x" />}
              />
            ),
          })
        })
    }

    dispatch({
      type: 'toggleRoyaltyPaymentModal',
      toggleNewPaymentModal: false,
    })
    dispatch({
      type: 'toggleCommissionPaymentModal',
      commissionModalOpen: true,
    })
    toggleRoyaltiesWorking(false)
  }

  let totalRoyaltyOwed = 0
  let totalRoyaltyPercentOwed = 0.0
  for (let i = 0; i < currentState.royaltiesOwed.length; i++) {
    totalRoyaltyOwed += currentState.royaltiesOwed[i].amount
    totalRoyaltyPercentOwed += parseFloat(currentState.royaltiesOwed[i].rate)
  }

  return (
    <Modal show={currentState.royaltyModalOpen}>
      <Modal.Header>
        <Modal.Title>Pay Royalties</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h1>
          <small>Payment Information</small>
        </h1>
        <Table condensed>
          <tbody>
            <tr>
              <td>Description</td>
              <td>{currentState.newPaymentDescription}</td>
            </tr>
            <tr>
              <td>Amount</td>
              <td>{currentState.newPaymentAmount}</td>
            </tr>
            <tr>
              <td>Stripe Transaction ID</td>
              <td>
                {currentState.newPaymentTransactionID ? (
                  currentState.newPaymentTransactionID
                ) : (
                  <i>None</i>
                )}
              </td>
            </tr>
            <tr>
              <td>Source</td>
              <td>
                {currentState.newSource ? currentState.newSource : <i>None</i>}
              </td>
            </tr>
            <tr>
              <td>Invoice Number</td>
              <td>
                {currentState.newInvoiceNumber ? (
                  currentState.newInvoiceNumber
                ) : (
                  <i>None</i>
                )}
              </td>
            </tr>
            <tr>
              <td>Course Number</td>
              <td>{currentState.newPaymentCoursenum}</td>
            </tr>
          </tbody>
        </Table>
        <div>
          <h1>
            <small>Associated Royalties</small>
          </h1>
          <Table bordered condensed>
            <thead>
              <tr>
                <th scope="col">Recipient</th>
                <th className="text-right" scope="col">
                  Rate
                </th>
                <th className="text-right" scope="col">
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {currentState.royaltiesOwed.map((royalty, i) => (
                <tr key={i}>
                  <td>{royalty.user_full_name}</td>
                  <td className="text-right">
                    {(royalty.rate * 100).toFixed(2)}%
                  </td>
                  <td className="text-right">
                    ${(royalty.amount / 100).toFixed(2)}
                  </td>
                </tr>
              ))}
              <tr>
                <td className="text-right">
                  <strong>Total</strong>
                </td>
                <td className="text-right">
                  <strong>{(totalRoyaltyPercentOwed * 100).toFixed(2)}%</strong>
                </td>
                <td className="text-right">
                  <strong>${(totalRoyaltyOwed / 100).toFixed(2)}</strong>
                </td>
              </tr>
            </tbody>
          </Table>
          {totalRoyaltyPercentOwed > 0.5 && (
            <Alert bsStyle="danger">
              Royalties for this course are over 50%. Make sure this is correct
              before continuing.
            </Alert>
          )}
          <p className="mb-4">
            Would you like to pay these royalties automatically?
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={() => {
            dispatch({
              type: 'toggleRoyaltyPaymentModal',
              toggleNewPaymentModal: false,
            })
            dispatch({
              type: 'toggleCommissionPaymentModal',
              commissionModalOpen: true,
            })
          }}
          className="btn-myed btn-default-myed"
        >
          <span className="far fa-times fa-fw mr-2" /> No, skip and go to
          Commissions
        </Button>
        <Button
          onClick={() => submitRoyalties()}
          className="btn-myed btn-primary-myed"
          bsStyle="primary"
          disabled={royaltiesWorking}
        >
          <span
            className={
              !royaltiesWorking
                ? 'far fa-check fa-fw mr-2'
                : 'far fa-spinner fa-spin fa-fw mr-2'
            }
          />{' '}
          Pay Royalties
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default RoyaltiesToPayModal
